"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = exports.AlertHeading = exports.AlertIcon = exports.ALLOWED_ALERT_TYPES = void 0;

var _reactIntl = require("react-intl");

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _IconDisplay = require("../icons/IconDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALLOWED_ALERT_TYPES = {
  ERROR: 'error',
  VALID: 'valid',
  WARNING: 'warning',
  SUPPLEMENTAL: 'supplemental',
  INFO: 'info'
};
exports.ALLOWED_ALERT_TYPES = ALLOWED_ALERT_TYPES;

var AlertIcon = function AlertIcon(props) {
  var alertType = props.alertType;
  var iconClass = (0, _dedupe.default)('alert-icon', {
    'alert-icon--error': alertType === ALLOWED_ALERT_TYPES.ERROR,
    'alert-icon--supplemental': alertType === ALLOWED_ALERT_TYPES.SUPPLEMENTAL,
    'alert-icon--info': alertType === ALLOWED_ALERT_TYPES.INFO
  });
  return _react.default.createElement("div", {
    className: iconClass
  }, _react.default.createElement(_IconDisplay.Icon, {
    type: alertType
  }));
};

exports.AlertIcon = AlertIcon;
AlertIcon.propTypes = {
  alertType: _propTypes.default.string.isRequired
};

var AlertHeading = function AlertHeading(props) {
  var alertType = props.alertType,
      heading = props.heading;
  var headlineClass = (0, _dedupe.default)('alert-heading', {
    'alert-heading--error': alertType === ALLOWED_ALERT_TYPES.ERROR,
    'alert-heading--supplemental': alertType === ALLOWED_ALERT_TYPES.SUPPLEMENTAL,
    'alert-heading--info': alertType === ALLOWED_ALERT_TYPES.INFO
  });
  return _react.default.createElement("h3", {
    className: headlineClass
  }, _react.default.createElement(_reactIntl.FormattedMessage, heading));
};

exports.AlertHeading = AlertHeading;
AlertHeading.propTypes = {
  alertType: _propTypes.default.string.isRequired,
  heading: _propTypes.default.object.isRequired
};

var Alert = function Alert(props) {
  var alertType = props.alertType,
      message = props.message,
      heading = props.heading,
      hasHeading = props.hasHeading;
  var containerClass = (0, _dedupe.default)('alert-container', {
    'alert-container--error': alertType === ALLOWED_ALERT_TYPES.ERROR,
    'alert-container--supplemental': alertType === ALLOWED_ALERT_TYPES.SUPPLEMENTAL,
    'alert-container--info': alertType === ALLOWED_ALERT_TYPES.INFO
  });
  var role = alertType === ALLOWED_ALERT_TYPES.ERROR ? 'alert' : null;
  return _react.default.createElement("div", {
    className: containerClass,
    role: role
  }, alertType !== ALLOWED_ALERT_TYPES.SUPPLEMENTAL ? _react.default.createElement(AlertIcon, {
    alertType: alertType
  }) : null, _react.default.createElement("div", {
    className: "alert-container__content"
  }, hasHeading ? _react.default.createElement(AlertHeading, {
    alertType: alertType,
    heading: heading
  }) : null, typeof message === 'string' ? _react.default.createElement(_markdownToJsx.default, null, message) : _react.default.createElement(_reactIntl.FormattedMessage, message)));
};

exports.Alert = Alert;
var allowedAlertTypes = Object.keys(ALLOWED_ALERT_TYPES).map(function (key) {
  // eslint-disable-line arrow-body-style
  return ALLOWED_ALERT_TYPES[key];
});
Alert.defaultProps = {
  heading: {},
  hasHeading: true
};
Alert.propTypes = {
  alertType: _propTypes.default.oneOf(allowedAlertTypes).isRequired,
  message: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]).isRequired,
  hasHeading: _propTypes.default.bool,
  heading: _propTypes.default.object
};